import {config} from "../AppConfig";


async function getDashboardStats() {
    const result = await fetch(`${config.url.API_BASE}/api/admin/statistics`, {
        method: "GET",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true
        }
    });

    if (result.status === 200){
        return await result.json();
    } else {
        return null;
    }
}

async function createPortalSession() {
    const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/stripe/portal/session`, {
        method: "POST",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true
        },
        body: JSON.stringify({})
    });

    return result.json();
}

async function downloadLatestVersion() {
    const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/dashboard/download`, {
        method: "GET",
        credentials: "include",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true
        }
    });

    return result.json();
}



export const dashboardService = {
    getDashboardStats,
    createPortalSession,
    downloadLatestVersion,
}


